/*
 * @Author: Fan
 * @Date: 2020-04-26 12:12:42
 * @description:
 * @LastEditors: Fan
 */
import { styleControlOptions } from "../../component-schema";
import { DataType } from "../../typings";
import i18n from "../../i18n";
export default {
    $id: "exRateex",
    type: DataType.Object,
    $ref: styleControlOptions.$id,
    properties: {
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
    },
};
